import { P } from '@ahmdigital/ui';
import styled from 'styled-components';

const PreLineParagraph = styled(P)`
  white-space: pre-line;
`;

export default PreLineParagraph;
